import { ActionIcon, Avatar, Badge, Box, Button, Grid, Group, Indicator, Loader, Menu, Modal, Paper, Tabs, Text, Title, Tooltip, UnstyledButton } from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import React, { useEffect, useState } from "react";
// import MapRender from "../components/map_render_v2";
import SimpleMap from "../components/simple_map";
import { useApp } from "../contexts/app.context";
import { GET_ALL_DEVICES, TRIGGER_DEVICE_COMMAND } from "../services/devices";
import { CANCEL_TRIP, FINISH_TRIP, GET_ALL_TRIPS, START_TRIP } from "../services/trips";
import { GET_ALL_VEHICLES, GET_VEHICLE_DETAILS } from "../services/vehicles";
import { createMarkerIcon, downloadGPX, downloadKML, formatAddress, formatDuration, generateMarkerText, getExtenseDatetime, getVehicleIcon, groupBy, vehiclePath } from "../utility/util";
import TotalTripsChart from "../components/charts/total_trips_chart";
import DevicesStatusChart from "../components/charts/devices_status_chart";
import { FaChevronLeft, FaClipboard, FaCopy, FaEllipsisV, FaPlus, FaTimesCircle } from "react-icons/fa";
import { GET_ALL_ROUTES, SAVE_TRAVEL } from "../services/routes";
import InputField, { InputFieldTypes } from "../components/input_field";
import moment from "moment-timezone";
import { Buffer } from 'buffer';
import { useClipboard } from "@mantine/hooks";
import { useAuth } from "../contexts/auth.context";

export default function Home(){
    const [typeView, setTypeView] = useState("vehicles");
    const [filters, setFilters] = useState({
      search: "",
      status: null,
    });
    const [selectedGroupTravels, setSelectedGroupTravels] = useState(null);
    const [selectedTravel, setSelectedTravel] = useState(null);
    const [loadingTravels, setLoadingTravels] = useState(false);
    const [loadingVehicles, setLoadingVehicles] = useState(false);
    const [travels, setTravels] = useState([]);
    const [selectedTraject, setSelectedTraject] = useState({});
    const [modalTravel, setModalTravel] = useState(null);
    const [vehicles, setVehicles] = useState([]);
    const [devices, setDevices] = useState([]);
    const [lastComunication, setLastComunication] = useState<any>({});
    const [vehicleDetails, setVehicleDetails] = useState<any>({});
    const [loadingVehicleDetails, setLoadingVehicleDetails] = useState<any>({});
    const [loadingCancelTrips, setLoadingCancelTrips] = useState<boolean>(false);
    const [selectedVehicle, setSelectedVehicle] = useState(null);
    const [selectedDate, setSelectedDate] = useState(moment().format());
    const [updatingTrips, setUpdatingTrips] = useState<any>(null);
    const [loadingTriggers, setLoadingTriggers] = React.useState<any>({});
    const [mapType, setMapType] = useState("location");

    const app = useApp();

    const travelVehicle = vehicles.find(v => v._id === selectedTravel?.vehicle?._id);
    const clipboard = useClipboard();
    const activeDeviceId = (selectedVehicle?.devices ?? [])[0]?.device?._id;

    const filterVehicles = (items, filters) => items.filter(v => (
      (
        (!filters.search) ||
        (v.license_plate ?? "").toLowerCase().includes(filters.search.toLocaleLowerCase()) ||
        (v.model ?? "").toLowerCase().includes(filters.search.toLocaleLowerCase()) ||
        (v.brand ?? "").toLowerCase().includes(filters.search.toLocaleLowerCase())
      ) &&
      (
        !filters?.status || (
          (lastComunication[v._id]?.datetime && moment().diff(moment(lastComunication[v._id].datetime), "hours") < 2)
          ? (lastComunication[v._id]?.props?.power === filters.status)
          : filters.status === "inactive"
        )
      )
    ))
    .sort((a,b) => `${a.model}-${a.brand}-${a.license_plate}` > `${b.model}-${b.brand}-${b.license_plate}` ? 1 : -1);
    const filteredVehicles = filterVehicles(vehicles, filters)

    const { socket } = useApp();
    const { currentCompany } = useAuth();

    const loadTravels = () => {
      setLoadingTravels(true)
      GET_ALL_TRIPS({ datetime: moment().format() })
      .then(res => {
        setTravels(res)
        setLoadingTravels(false)
        setSelectedTravel(s => {
          let existent = res.find(r => s && r.id === s.id);
          if(existent) return existent;
          return s;
        })
      })
      .catch(err => {
        setLoadingTravels(false)
        showNotification({title: "Ops", message: err.message, color: 'red'})
      })
    }

    const cancelTrips = async (travelsIds = []) => {
      setLoadingCancelTrips(true)

      try{
        await Promise.all(travelsIds.map(tid => CANCEL_TRIP(tid)))
        setLoadingCancelTrips(false)
        loadTravels();
      }catch(err){
        setLoadingCancelTrips(false)
        showNotification({title: "Ops", message: err.message, color: 'red'})
      }
    }

    const updateTrips = async (travelsIds = []) => {
      setLoadingCancelTrips(true);

      try{
        await Promise.all(travelsIds.map(tid => SAVE_TRAVEL({ ...updatingTrips, _id: tid })))
        setLoadingCancelTrips(false);
        setUpdatingTrips(null);
        loadTravels();
      }catch(err){
        setLoadingCancelTrips(false)
        showNotification({title: "Ops", message: err.message, color: 'red'})
      }
    }
    
    const loadVehicles = () => {
      setLoadingVehicles(true)
      GET_ALL_VEHICLES()
      .then(res => {
        setLoadingVehicles(false)
        setVehicles(res)
      })
      .catch(err => {
        setLoadingVehicles(false)
        showNotification({title: "Ops", message: err.message, color: 'red'})
      })
    }

    const loadVehicleDetails = (vehicleId) => {
      setLoadingVehicleDetails(vd => ({...vd, [vehicleId]: true}))
      GET_VEHICLE_DETAILS(vehicleId, selectedDate)
      .then(res => {
        setLoadingVehicleDetails(vd => ({...vd, [vehicleId]: false}))
        setVehicleDetails(vd => ({...vd, [vehicleId]: res}));
        if((res.history ?? []).length === 0) setMapType("location");
      })
      .catch(err => {
        setLoadingVehicleDetails(vd => ({...vd, [vehicleId]: false}))
        showNotification({title: "Ops", message: err.message, color: 'red'})
      })
    }
    
    const loadDevices = () => {
      GET_ALL_DEVICES()
      .then(res => { setDevices(res) })
      .catch(err => { showNotification({title: "Ops", message: err.message, color: 'red'}) })
    }

    const exportGPX = (vehicle, traject) => {
      let histories = traject.histories ?? [{}];
      const start = moment(histories[0].datetime);
      const finish = moment(histories[histories.length - 1].datetime);

      downloadGPX({
        start,
        finish,
        histories,
        title: `${vehicle.license_plate}_${start.format("YYYY_MM_DD_HH_MM")}_${finish.format("YYYY_MM_DD_HH_MM")}`,
      })
    }
    
    const exportKML = (vehicle, traject) => {
      let histories = traject.histories ?? [{}];
      const start = moment(histories[0].datetime);
      const finish = moment(histories[histories.length - 1].datetime);

      downloadKML({
        start,
        finish,
        histories,
        title: `${vehicle.license_plate}_${start.format("YYYY_MM_DD_HH_MM")}_${finish.format("YYYY_MM_DD_HH_MM")}`,
      })
    }

    const renderGroupedTravel = ([route, items = []]) => {
      return <React.Fragment key={route._id}>
        <UnstyledButton
          key={`${route._id}`}
          style={{ width: "100%" }}
          // onClick={() => { selectedGroupTravels?._id === route._id ? setSelectedGroupTravels(null) : setSelectedGroupTravels(route) }}
        >
          <div
            style={{
              padding: 10,
              borderBottom: "1px solid #DFDFDF",
              // borderRight: (selectedGroupTravels?._id === route._id) ? "5px solid #ff7400" : "5px solid #00000000",
              minHeight: 80,
              transition: '0.5s all'
            }}
          >
            <Text size="md">{route.route_long_name ?? route.route_short_name}</Text>
            <Group mt="sm">
              {items.map((travel) => (
                <UnstyledButton onClick={() => setSelectedTravel(travel)}>
                  <Badge
                    variant={
                      (selectedTravel?.id === travel.id)
                      ? "filled"
                      : "outline"
                    }
                    color={{
                      '2': "green",
                      '1': "yellow",
                      '0': "orange",
                      '-1': "red",
                    }[`${travel.status}`] ?? "orange"}
                  >{moment(travel.datetime).format("HH:mm")}</Badge>
                </UnstyledButton>
              ))}
            </Group>
            <Group mt="sm" style={{justifyContent: 'flex-end'}}>
              <Button
                disabled={loadingCancelTrips}
                color="red"
                variant="outline"
                size="xs"
                onClick={() => {
                  app.confirmDialog(
                    {text: "Realmente deseja cancelar todas as viagens desse dia?"},
                    (({confirmed}) => { if(confirmed) cancelTrips(items.map(it => it.id)); })
                  )
                }}
              >Cancelar</Button>
              <Button
                color="blue"
                variant="outline"
                size="xs"
                onClick={() => { setUpdatingTrips({ route: route._id, travelsIds: items.map(item => item.id) }) }}
              >Editar</Button>
            </Group>
          </div>
        </UnstyledButton>
      </React.Fragment>
    }

    const triggerCommand = (deviceId: string, key: string) => {
      setLoadingTriggers(lt => ({...lt, [deviceId]: { ...lt[deviceId], [key]: true }}))
      TRIGGER_DEVICE_COMMAND(deviceId, key)
      .then(res => {
          showNotification({message: "Comando enviado", color: "orange"})
          setLoadingTriggers(lt => ({...lt, [deviceId]: { ...lt[deviceId], [key]: false }}))
      })
      .catch(err => {
          showNotification({message: err.message, color: "red"})
          setLoadingTriggers(lt => ({...lt, [deviceId]: { ...lt[deviceId], [key]: false }}))
      })
    }

    const renderItemList = (trip, k) => (
        <React.Fragment key={k}>
          <UnstyledButton
            key={`${trip._id}`}
            style={{ width: "100%" }}
            onClick={() => { selectedTravel?.id === trip.id ? setSelectedTravel(null) : setSelectedTravel(trip) }}
          >
            <div
              style={{
                padding: 10,
                borderBottom: "1px solid #DFDFDF",
                borderRight: (selectedTravel?.id === trip.id) ? "5px solid #ff7400" : "5px solid #00000000",
                minHeight: 80,
                transition: '0.5s all'
              }}
            >
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%" }}>
                <div style={{ flex: 1, minWidth: "100%", maxWidth: "100%", paddingLeft: 16 }} >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Text
                      size="sm"
                      weight="bold"
                      className="max-lines-1"
                      style={{ flex: 1 }}
                    >
                      {trip.title} - ({trip.direction === 1 ? "Volta" : "Ida"})
                    </Text>
                  </div>
                  <Text size="xs" mt="xs">Motorista: {trip?.driver?.name || "Sem motorista"} | {trip?.vehicle?.license_plate ? `Veículo: ${trip?.vehicle?.license_plate}` : "Sem veículo"}</Text>
                  
                  <Box pt="xs" pb="xs">
                    {(trip.tags || []).map((t, k) => (
                      <Badge color="violet" size="xs" mr="xs" key={k}>
                        {t.title}
                      </Badge>
                    ))}
                  </Box>
                  <Group>
                    {trip.status === 2 && <Badge color="green">Finalizado</Badge>}
                    {trip.status === 1 && <Badge color="yellow">Em andamento</Badge>}
                    {trip.status === 0 && <Badge color="orange">Agendado</Badge>}
                    {trip.status === -1 && <Badge color="red">Cancelado</Badge>}
                    <div style={{flex: 1}}></div>
                    <Text size="xs" align="right" color="gray" weight="bold">
                        {getExtenseDatetime(trip.datetime)}
                    </Text>
                  </Group>
                </div>
              </div>
            </div>
          </UnstyledButton>
        </React.Fragment>
    );
    
    const renderVehicle = (vehicle, k) => (
      <React.Fragment key={k}>
        <UnstyledButton
          key={`${vehicle._id}`}
          style={{ width: "100%" }}
          onClick={() => { selectedVehicle?._id === vehicle._id ? setSelectedVehicle(null) : setSelectedVehicle(vehicle) }}
        >
          <div
            style={{
              padding: '15px 20px',
              borderBottom: "1px solid #DFDFDF",
              borderRight: (selectedVehicle?._id === vehicle._id) ? "5px solid #ff7400" : "5px solid #00000000",
              transition: '0.5s all'
            }}
          >
            <Group>
              <Tooltip label={
                  (lastComunication[vehicle._id] && moment().diff(moment(lastComunication[vehicle._id].datetime), "hours") < 2)
                  ? lastComunication[vehicle._id]?.props?.power === "on" ? "Veículo Ligado" : "Veículo Desligado"
                  : "Sem comunicação"}>
                <ActionIcon
                  variant="light"
                  size={50}
                  style={{ borderWidth: 2, borderRadius: 50 }}
                  color={
                      (lastComunication[vehicle._id] && moment().diff(moment(lastComunication[vehicle._id].datetime), "hours") < 2)
                      ? lastComunication[vehicle._id] ? `${lastComunication[vehicle._id]?.props?.power === "on" ? "green" : "red"}` : 'gray'
                      : "gray"}
                >
                  <img
                    src={getVehicleIcon(vehicle.type)}
                    style={{ height: 20, color: "white", fill: "invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%)" }}
                  />
                </ActionIcon>
              </Tooltip>
              
              <Box style={{flex: 1, paddingLeft: 10}}>
                <Text size="sm">{`${vehicle.brand} ${vehicle?.model}`}</Text>
                <Text size="sm" c="gray">{vehicle?.license_plate ? `Placa: ${vehicle?.license_plate}` : "Sem Placa"}</Text>
                <Text size="xs" c="gray">{formatAddress((vehicle?.devices ?? [])[0]?.device?.lastHistory?.props)}</Text>
                {lastComunication[vehicle._id] && <Tooltip label="Última comunicação">
                  {moment().diff(moment(lastComunication[vehicle._id].datetime), "hours") > 2
                      ? <Text ta="right" size="xs" color="gray">{moment(lastComunication[vehicle._id].datetime).format("DD/MM/YYYY HH:mm")}</Text>
                      : <Text ta="right" size="xs" color="gray">{moment(lastComunication[vehicle._id].datetime).format("HH:mm")}</Text>
                  }
                </Tooltip>}
              </Box>
            </Group>
          </div>
        </UnstyledButton>
      </React.Fragment>
    );

    useEffect(() => {
      loadVehicles()
      loadTravels()
      loadDevices()
    }, []);

    useEffect(() => {
      let np : any = {};
      for(let v of vehicles){
        np[v._id] = v.last_comunication;
      }
      setLastComunication(lc => ({ ...lc, ...np }))
    }, [vehicles])
    
    useEffect(() => {
      if(selectedVehicle && typeView === "vehicles") loadVehicleDetails(selectedVehicle._id);
    }, [selectedVehicle, selectedDate, typeView])
    
    useEffect(() => {
      setSelectedTraject({});
    }, [selectedDate])

    useEffect(() => {
      if(socket){
        const callback = (vehicle) => ({ history }) => {
          setLastComunication(lc => ({ ...lc, [vehicle]: history}))
        }
        let devices = vehicles.reduce((pv, v) => pv.concat(v.devices ?? []), []);
        for(let d of devices){ socket.on(`device-history-received-${d.device?._id}`, callback(d.vehicle)); }
        return () => {
          for(let d of devices){ socket.off(`device-history-received-${d.device?._id}`, callback(d.vehicle)) }
        }
      }
    }, [socket, vehicles])

    return <div style={{position: 'relative'}}>
        <Grid>
          <Grid.Col md={4} sm={12}>
            <Paper>
              <Group spacing={0} align="flex-end">
                <Tabs style={{flex: 1}} value={typeView} onTabChange={setTypeView}>
                  <Tabs.List>
                    <Tabs.Tab value="vehicles">Veículos</Tabs.Tab>
                    {currentCompany?.company?.resources?.trips && <Tabs.Tab value="travels">Viagens</Tabs.Tab>}
                  </Tabs.List>
                </Tabs>
                {/* <div style={{borderBottom: '2px solid #dee2e6'}}>
                  <Menu>
                    <Menu.Target>
                      <ActionIcon><FaEllipsisV /></ActionIcon>
                    </Menu.Target>
                    <Menu.Dropdown>
                      
                    </Menu.Dropdown>
                  </Menu>
                </div> */}
              </Group>
            </Paper>
            {
              typeView === "vehicles" && <Paper shadow="xs" style={{height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column'}}>
                {loadingVehicles && <Loader m="md" size="xs" />}
                <div style={{flex: 1, overflowY: 'auto'}}>
                  {selectedVehicle
                  ? <>
                    <Group p="sm">
                      <ActionIcon
                        onClick={() => {
                          setSelectedVehicle(null);
                          setMapType("location");
                          setSelectedTraject(st => ({ ...st, [selectedVehicle._id]: null }))
                        }}
                        size="md"
                        variant="light"
                      >
                        <FaChevronLeft />
                      </ActionIcon>
                      <Text style={{flex: 1}} size="sm" fw="bold">{
                        [
                          selectedVehicle.license_plate,
                          selectedVehicle.brand,
                          selectedVehicle.model,
                        ].filter(nn => nn).join(" - ")
                      }</Text>
                      <InputField
                        name="date"
                        value={moment(selectedDate).toDate()}
                        fieldType={InputFieldTypes.DATE}
                        clearable={false}
                        onChange={({date}) => setSelectedDate(date)}
                      />
                    </Group>
                    <Box p="md">
                      <Text size="sm" c="gray">Ações</Text>
                      <Button
                        fullWidth
                        variant="light"
                        mt="md"
                        disabled={!activeDeviceId}
                        loading={{...loadingTriggers[activeDeviceId]}["block"]}
                        onClick={() => {
                          app.confirmDialog({ text: "Realmente deseja Bloquear esse veículo?" }, ({ confirmed }) => {
                            triggerCommand(activeDeviceId, "block")
                          })
                        }}
                      >Bloquear Veículo</Button>
                      <Button
                        fullWidth
                        variant="light"
                        mt="md"
                        disabled={!activeDeviceId}
                        loading={{...loadingTriggers[activeDeviceId]}["unblock"]}
                        onClick={() => {
                          app.confirmDialog({ text: "Realmente deseja Desbloquear esse veículo?" }, ({ confirmed }) => {
                            triggerCommand(activeDeviceId, "unblock")
                          })
                        }}
                      >Desbloquear Veículo</Button>
                    </Box>
                    <Text p="md" size="sm" c="gray">Trajetos</Text>
                    {
                      loadingVehicleDetails[selectedVehicle?._id]
                      ? <Loader m="lg" size="sm" />
                      : (vehicleDetails[selectedVehicle?._id]?.totals?.trajects ?? []).length === 0 &&
                        <Text p="md" size="md" color="gray">Nenhum trajeto para a data selecionada</Text>
                    }
                    {
                      (vehicleDetails[selectedVehicle?._id]?.totals?.trajects ?? []).map((traject, i) => <Box
                        style={{borderTop: '1px solid #DFDFDF', background: selectedTraject[selectedVehicle._id]?.index === i ? '#F0F0F0' : 'transparent'}}
                        p="xs" 
                      >
                        <Group mb="xs">
                          <Box style={{background: '#F4F4F4', padding: '2px 5px', borderRadius: 5}}>
                            <Text ta="center" color="orange" size="xs">A</Text>
                            <Text ta="left" size={8} c="gray">{moment(traject.histories[0].datetime).format("HH:mm")}</Text>
                          </Box>
                          <Text style={{flex: 1}} size="xs">{formatAddress({address: traject.histories[0].props?.address, location: traject.histories[0]?.props?.location})}</Text>
                        </Group>
                        {traject.histories.length > 1 && <Group>
                          <Box style={{background: '#F4F4F4', padding: '2px 5px', borderRadius: 5}}>
                            <Text ta="center" color="green" size="xs">B</Text>
                            <Text ta="left" size={8} c="gray">{moment(traject.histories[traject.histories.length - 1].datetime).format("HH:mm")}</Text>
                          </Box>
                          <Text style={{flex: 1}} size="xs">{formatAddress({address: traject.histories[traject.histories.length - 1].props?.address, location: traject.histories[traject.histories.length - 1]?.props?.location})}</Text>
                        </Group>}
                        <Group position="right" mt="xs">
                          <Button
                            onClick={() => {
                              setMapType("traject")
                              setSelectedTraject(st => ({
                                ...st,
                                [selectedVehicle._id]: selectedTraject[selectedVehicle._id]?.index === i
                                ? null
                                : { index: i, histories: traject.histories }
                              }))
                            }}
                            variant="filled" size="xs">Detalhes</Button>
                          <Menu>
                            <Menu.Target>
                              <Button variant="outline" size="xs">Exportar</Button>
                            </Menu.Target>
                            <Menu.Dropdown>
                                <Menu.Item onClick={() => exportGPX(selectedVehicle, traject)}>Exportar GPX</Menu.Item>
                                <Menu.Item onClick={() => exportKML(selectedVehicle, traject)}>Exportar KML</Menu.Item>
                            </Menu.Dropdown>
                        </Menu>
                          
                        </Group>
                      </Box>)
                    }
                  </>
                  : <>
                    <Box p="xs">
                      <InputField
                        name="search"
                        // title="Buscar veículo"
                        placeholder="Buscar veículo"
                        value={filters.search}
                        onChange={({search}) => setFilters(f => ({...f, search}))}
                      />
                    </Box>
                    {filteredVehicles.length === 0 && <Text m="lg" color="gray" size="sm" align="center">Nenhum veículo para o filtro selecionado</Text>}
                    {filteredVehicles.map(renderVehicle)}
                  </>}
                </div>
              </Paper>
            }
            {
              typeView === "travels" && <Paper shadow="xs" style={{height: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column'}}>
                {loadingTravels && <Loader m="md" size="xs" />}
                {travels.length === 0 && <Text m="lg" color="gray" size="sm" align="center">Nenhuma viagem programada para hoje</Text>}
                <div style={{flex: 1, overflowY: 'auto'}}>
                  {/* {travels.map(renderItemList)} */}
                  {groupBy(travels, t => t.route, "_id").map(renderGroupedTravel)}
                </div>
                <Box p="md">
                  <Button onClick={() => setModalTravel({})} variant="outline" fullWidth leftIcon={<FaPlus />}>Adicionar viagem</Button>
                </Box>
              </Paper>
            }
          </Grid.Col>
          <Grid.Col md={8} sm={12}>
            <Grid>
              <Grid.Col md={12} sm={12}>
                <Paper p="md" shadow="xs">
                  <Group grow>
                    <UnstyledButton onClick={() => setFilters(f => ({...f, status: null}))}>
                      <Paper p="xs" shadow="xs" style={filters.status === null ? { border: "2px solid #AAAAAA" } : {}}>
                        <Group>
                          <Badge color="orange" variant="outline">{filterVehicles(vehicles, {status: null}).length}</Badge>
                          <Text size="xs" ta="center" style={{flex: 1}}>Todos</Text>
                        </Group>
                      </Paper>
                    </UnstyledButton>
                    <UnstyledButton onClick={() => setFilters(f => ({...f, status: "on"}))}>
                      <Paper p="xs" shadow="xs" style={filters.status === "on" ? { border: "2px solid #AAAAAA" } : {}}>
                        <Group>
                          <Badge color="green" variant="outline">{filterVehicles(vehicles, {status: "on"}).length}</Badge>
                          <Text size="xs" ta="center" style={{flex: 1}}>Ligados</Text>
                        </Group>
                      </Paper>
                    </UnstyledButton>
                    <UnstyledButton onClick={() => setFilters(f => ({...f, status: "off"}))}>
                      <Paper p="xs" shadow="xs" style={filters.status === "off" ? { border: "2px solid #AAAAAA" } : {}}>
                        <Group>
                          <Badge color="red" variant="outline">{filterVehicles(vehicles, {status: "off"}).length}</Badge>
                          <Text size="xs" ta="center" style={{flex: 1}}>Desligados</Text>
                        </Group>
                      </Paper>
                    </UnstyledButton>
                    <UnstyledButton onClick={() => setFilters(f => ({...f, status: "inactive"}))}>
                      <Paper p="xs" shadow="xs" style={filters.status === "inactive" ? { border: "2px solid #AAAAAA" } : {}}>
                        <Group>
                          <Badge color="gray" variant="outline">{filterVehicles(vehicles, {status: "inactive"}).length}</Badge>
                          <Text size="xs" ta="center" style={{flex: 1}}>Sem comunicação</Text>
                        </Group>
                      </Paper>
                    </UnstyledButton>
                  </Group>
                </Paper>
              </Grid.Col>
              <Grid.Col md={12} sm={12}>
                {typeView === "travels" && <TripRender
                  data={selectedTravel}
                  vehicle={travelVehicle ? {
                    location: lastComunication[travelVehicle._id]?.props?.location
                  } : null}
                  onEdit={() => setModalTravel({ _id: selectedTravel.id, route: selectedTravel.route, datetime: selectedTravel.datetime, vehicle: selectedTravel?.vehicle?._id })}
                  onUpdate={() => {
                    loadTravels();
                  }}
                />}
                {typeView === "vehicles" && <>
                  <div style={{position: 'relative'}}>
                    {/* {selectedVehicle && <Group style={{position: 'absolute', top: 0, left: '50%', zIndex: 10}}>
                      <div style={{position: 'relative', left: '-50%'}}>
                        <Button
                            onClick={() => setMapType("location")}
                            color="gray"
                            variant="outline"
                            c="black"
                            fw={mapType === "location" ? "weight" : "normal"}
                            style={{
                                padding: '10px 20px',
                                minWidth: '125px', margin: 10,
                                background: 'white',
                                borderRadius: 5, borderWidth: mapType === "location" ? 3 : 1, borderColor: '#4a4a4a'
                            }}>
                            Localização
                        </Button>
                        <Button
                            onClick={() => {
                                if((vehicleDetails[selectedVehicle?._id]?.history ?? []).length > 0){
                                  setMapType("traject")
                                }else{
                                  showNotification({ title: "Sem trajeto", message: "No dia selecionado não houve nenhum trajeto do veículo" });
                                }
                            }}
                            color="gray"
                            variant="outline"
                            c="black"
                            fw={mapType === "traject" ? "weight" : "normal"}
                            style={{
                                padding: '10px 20px',
                                minWidth: '125px', margin: 10,
                                background: 'white',
                                borderRadius: 5, borderWidth: mapType === "traject" ? 3 : 1, borderColor: '#4a4a4a'
                            }}>
                            Trajeto
                        </Button>
                      </div>
                    </Group>} */}
                  </div>

                  <SimpleMap
                    line={!!selectedTraject[selectedVehicle?._id]}
                    // icon={{
                      // path: 'M11.0639 15.3003L26.3642 2.47559e-05L41.6646 15.3003L26.3638 51.3639L11.0639 15.3003 M22,17.5a4.5,4.5 0 1,0 9,0a4.5,4.5 0 1,0 -9,0Z',
                      // path: vehiclePath,
                      // fillColor: "#FF0000",
                      // fillOpacity: 0.8,
                      // strokeColor: 'pink',
                      // strokeWeight: 2,
                      // anchor: new google.maps.Point(30, 50)
                    // }}
                    onMarkerClick={(e, { index }) => !selectedVehicle && setSelectedVehicle(vehicles[index])}
                    markers={
                      (
                        !!selectedTraject[selectedVehicle?._id]
                        ? (selectedTraject[selectedVehicle?._id].histories ?? []).map(h => (h.props.location))
                        : filteredVehicles.filter(v => !selectedVehicle || selectedVehicle._id === v._id).map(v => (
                          lastComunication[v._id]?.props?.location
                        ))
                      ).filter(nn => nn)
                    }
                    icons={
                      !!selectedTraject[selectedVehicle?._id]
                      ? [
                        { icon: createMarkerIcon("A"), ...selectedTraject[selectedVehicle?._id]?.histories[0]?.props?.location },
                        selectedTraject[selectedVehicle?._id]?.histories.length > 1
                        ? { icon: createMarkerIcon("B"), ...selectedTraject[selectedVehicle?._id]?.histories[selectedTraject[selectedVehicle?._id]?.histories.length - 1]?.props?.location }
                        : null,
                      ].filter(nn => nn)
                      : []
                    }
                    height={selectedVehicle ? "300px" : "500px"}
                  />
                </>
                }
              </Grid.Col>
              {typeView === "vehicles" && <Grid.Col md={12} sm={12}>
                {!selectedVehicle
                ? <Paper shadow="xs" p="lg">
                  <Text color="gray" ta="center">Selecione um veículo para mais detalhes</Text>
                </Paper>
                : <Paper shadow="xs" p="lg">
                  {loadingVehicleDetails[selectedVehicle?._id] && <Loader size="sm" />}
                  <Title order={5}>{selectedVehicle.license_plate} - {selectedVehicle.model} {selectedVehicle.brand}</Title>
                  {(vehicleDetails[selectedVehicle?._id]?.activeTravels ?? []).length > 0 && <>
                    <Title order={5}>Viagens em andamento</Title>
                    <div style={{overflowX: 'auto', whiteSpace: 'nowrap', display: 'flex', flexDirection: 'row', marginBottom: 10}}>
                      {(vehicleDetails[selectedVehicle?._id]?.activeTravels ?? []).map(trip => (
                        <UnstyledButton onClick={() => {
                          setSelectedTravel(trip);
                          setTypeView("travels")
                        }}>
                        <Box mr="md" p="xs" style={{minWidth: 120, borderRadius: 5, border: '1px solid #DFDFDF', display: 'flex', flexDirection: 'column'}}>
                          <div style={{ flex: 1, minWidth: "100%", maxWidth: "100%", paddingLeft: 16 }} >
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <Text
                                size="sm"
                                weight="bold"
                                className="max-lines-1"
                                style={{ flex: 1 }}
                              >
                                {trip.title} - ({trip.direction === 1 ? "Volta" : "Ida"})
                              </Text>
                            </div>
                            <Text size="xs" mt="xs">Motorista: {trip?.driver?.name || "Sem motorista"} | {trip?.vehicle?.license_plate ? `Veículo: ${trip?.vehicle?.license_plate}` : "Sem veículo"}</Text>
                            
                            <Box pt="xs" pb="xs">
                              {(trip.tags || []).map((t, k) => (
                                <Badge color="violet" size="xs" mr="xs" key={k}>
                                  {t.title}
                                </Badge>
                              ))}
                            </Box>
                            <Group>
                              {trip.status === 2 && <Badge color="green">Finalizado</Badge>}
                              {trip.status === 1 && <Badge color="yellow">Em andamento</Badge>}
                              {trip.status === 0 && <Badge color="orange">Agendado</Badge>}
                              {trip.status === -1 && <Badge color="red">Cancelado</Badge>}
                              <div style={{flex: 1}}></div>
                              <Text size="xs" align="right" color="gray" weight="bold">
                                  {getExtenseDatetime(trip.datetime)}
                              </Text>
                            </Group>
                          </div>
                        </Box>
                        </UnstyledButton>
                      ))}
                    </div>
                  </>}
                  <Group>
                    <Box style={{overflow: 'hidden', width: '100%'}}>
                      <Group align="flex-start">
                        <Box style={{flex: 1}}>
                          <Title order={5}>Último Status</Title>
                          <Group mb="xs" mt="xs">
                            <Box>
                              {vehicleDetails[selectedVehicle?._id]?.address && <>
                                <Text size="xs">{formatAddress({ address: vehicleDetails[selectedVehicle?._id]?.address})}</Text>
                              </>}
                              <Text size="xs" color="gray">{vehicleDetails[selectedVehicle?._id]?.location?.latitude}, {vehicleDetails[selectedVehicle?._id]?.location?.longitude}</Text>
                            </Box>
                            <ActionIcon size="xs" color="gray" onClick={() => {
                              let txt = formatAddress({
                                address: vehicleDetails[selectedVehicle?._id]?.address,
                                location: vehicleDetails[selectedVehicle?._id]?.location,
                              });
                              clipboard.copy(txt);
                              showNotification({message:"Endereço copiado"})
                            }}><FaCopy /></ActionIcon>
                          </Group>
                        </Box>
                        <Text size="sm" fw="normal">{vehicleDetails[selectedVehicle?._id]?.location?.datetime ? getExtenseDatetime(vehicleDetails[selectedVehicle?._id]?.location?.datetime) : "-"}</Text>
                      </Group>
                      <div style={{display: 'flex', padding: '5px 0', flexDirection: 'row', width: '100%', overflowX: 'auto', flexWrap: 'nowrap'}}>
                        {[
                          { 
                              value: vehicleDetails[selectedVehicle?._id]?.power === "on" ? `Ligado` : `Desligado`,
                              title: "Status" },
                          { 
                              value: `${vehicleDetails[selectedVehicle?._id]?.speed ?? 0}km/h`,
                              title: "Velocidade" },
                          { 
                              value: `${(vehicleDetails[selectedVehicle?._id]?.traveled_distance ?? 0)/100} km`,
                              title: "Odômetro" },
                        ].map(item => (
                            <Box mr="md" p="xs" style={{minWidth: 120, borderRadius: 5, border: '1px solid #DFDFDF', display: 'flex', flexDirection: 'column'}}>
                              <Text style={{flex: 1}} size={12} ta="center">{item.title}</Text>
                              <Text ta="center" size={16} weight='bold'>{item.value}</Text>
                            </Box>
                        ))}
                      </div>
                    </Box>
                    <Box style={{overflow: 'hidden'}}>
                      <Group>
                        <Title order={5} style={{flex: 1}}>Resumo do dia:</Title>
                        <InputField
                          name="date"
                          value={moment(selectedDate).toDate()}
                          fieldType={InputFieldTypes.DATE}
                          clearable={false}
                          onChange={({date}) => setSelectedDate(date)}
                        />
                      </Group>
                      <div style={{display: 'flex', padding: '5px 0', flexDirection: 'row', width: '100%', overflowX: 'auto', flexWrap: 'nowrap'}}>
                        {[
                          { 
                              value: `${((vehicleDetails[selectedVehicle?._id]?.totals?.hodometerDistance ?? 0)/1000).toFixed(2)} km`,
                              title: "Distância Percorrida" },
                          { 
                              value: `${formatDuration(vehicleDetails[selectedVehicle?._id]?.totals?.movingTime ?? 0)}`,
                              title: "Tempo Ligado" },
                          { 
                              value: `${formatDuration(vehicleDetails[selectedVehicle?._id]?.totals?.stoppedTime ?? 0)}`,
                              title: "Tempo Desligado" },
                          { 
                              value: `${(vehicleDetails[selectedVehicle?._id]?.totals?.trajects ?? []).length}`,
                              title: "Quantidade de Percursos" },
                          { 
                              value: `${vehicleDetails[selectedVehicle?._id]?.totals?.numStops ?? 0}`,
                              title: "Quantidade de Paradas" },
                          { 
                              value: `${(vehicleDetails[selectedVehicle?._id]?.totals?.maxSpeed ?? 0).toFixed(1)} km/h`,
                              title: "Velocidade Máxima" },
                          { 
                              value: `${(vehicleDetails[selectedVehicle?._id]?.totals?.mediumSpeed ?? 0).toFixed(1)} km/h`,
                              title: "Velocidade Média" },
                      ].map(item => (
                          <Box mr="md" p="xs" style={{minWidth: 120, borderRadius: 5, border: '1px solid #DFDFDF', display: 'flex', flexDirection: 'column'}}>
                              <Text style={{flex: 1}} size={12} ta="center">{item.title}</Text>
                              <Text ta="center" size={16} weight='bold'>{item.value}</Text>
                          </Box>
                      ))}
                    </div>
                  </Box>
                  </Group>
                </Paper>}
              </Grid.Col>}
            </Grid>
          </Grid.Col>
        </Grid>

        <Modal
          opened={!!updatingTrips}
          onClose={() => setUpdatingTrips(null)}
          styles={{content: { minHeight: 400 }}}
        >
          <InputField
            mb="sm"
            name="vehicle"
            value={updatingTrips?.vehicle}
            onChange={({vehicle}) => setUpdatingTrips(dt => ({ ...dt, vehicle }))}
            title="Veículo"
            fieldType={InputFieldTypes.SELECT}
            options={vehicles.map(r => ({ value: r._id, label: `${r.model} - ${r.license_plate}` }))}
          />
          <Group>
            <Button
              loading={loadingCancelTrips}
              disabled={!updatingTrips?.vehicle}
              onClick={() => updateTrips(updatingTrips.travelsIds)}>Salvar</Button>
          </Group>
        </Modal>

        <TravelModal
          opened={Boolean(modalTravel)}
          data={modalTravel}
          vehicles={vehicles}
          onClose={() => setModalTravel(null)}
          onSave={() => { loadTravels(); setModalTravel(null); }}
        />
    </div>
}

const TravelModal = ({ data: dataParent, opened, onClose, onSave, vehicles = [] }) => {
  const [routes, setRoutes] = useState([]);
  const [data, setData] = useState(null);
  const [loadingRoutes, setLoadingRoutes] = useState(false);
  const [loadingVehicles, setLoadingVehicles] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);

  const loadRoutes = () => {
    setLoadingRoutes(true)
    GET_ALL_ROUTES()
    .then(r => {
      setLoadingRoutes(false)
      setRoutes(r)
    })
    .catch(err => {
      setLoadingRoutes(false)
      showNotification({ title: "Ops", message: err.message, color: 'red' })
    })
  }
  
  const handleSave = () => {
    setLoadingSave(true)
    SAVE_TRAVEL(data)
    .then(r => {
      setLoadingSave(false)
      onSave && onSave()
    })
    .catch(err => {
      setLoadingSave(false)
      showNotification({ title: "Ops", message: err.message, color: 'red' })
    })
  }

  useEffect(() => { loadRoutes() }, [])
  useEffect(() => {
    if(dataParent) setData({
      datetime: moment().toDate(),
      direction: "0",
      ...dataParent
    })
  }, [dataParent])

  return <Modal
    opened={opened}
    onClose={onClose}
    styles={{content: {minHeight: 500}}}
  >
    {!data?._id && <InputField
      mb="sm"
      name="datetime"
      value={data?.datetime}
      onChange={({datetime}) => setData(dt => ({ ...dt, datetime }))}
      title="Data e horário"
      fieldType={InputFieldTypes.DATETIME}
    />}
    
    {!data?._id && <InputField
      mb="sm"
      name="route"
      value={data?.route}
      onChange={({route}) => setData(dt => ({ ...dt, route }))}
      title="Itinerário"
      fieldType={InputFieldTypes.SELECT}
      options={routes.map(r => ({ value: r._id, label: `${r.route_short_name} - ${r.route_long_name}` }))}
    />}
    
    <InputField
      mb="sm"
      name="vehicle"
      value={data?.vehicle}
      onChange={({vehicle}) => setData(dt => ({ ...dt, vehicle }))}
      title="Veículo"
      fieldType={InputFieldTypes.SELECT}
      options={vehicles.map(r => ({ value: r._id, label: `${r.model} - ${r.license_plate}` }))}
    />
    
    {!data?._id && <InputField
      mb="sm"
      name="direction"
      value={data?.direction}
      onChange={({direction}) => setData(dt => ({ ...dt, direction }))}
      title="Rota (ida ou volta)"
      fieldType={InputFieldTypes.SELECT}
      options={[
        { label: "Ida", value: "0" },
        { label: "Volta", value: "1" },
      ]}
    />}

    <Group position="right" mt="lg">
      <Button color="orange" variant="white" onClick={onClose}>Cancelar</Button>
      <Button color="orange" onClick={handleSave}>Salvar</Button>
    </Group>
  </Modal>
}

const TripRender = ({ data, vehicle, onUpdate, onEdit }) => {
  const [typePresent, setTypePresent] = useState("route");
  const [loadingCancel, setLoadingCancel] = useState(false);
  const [loadingStart, setLoadingStart] = useState(false);
  const [loadingFinish, setLoadingFinish] = useState(false);
  
  const app = useApp();

  const cancelTrip = () => {
    setLoadingCancel(true)
    CANCEL_TRIP(data.id)
    .then(() => {
      setLoadingCancel(false)
      onUpdate && onUpdate();
    })
    .catch((err) => {
      setLoadingCancel(false)
      showNotification({title: "Ops", message: err.message, color: 'red'})
    })
  }
  
  const startTrip = () => {
    setLoadingStart(true)
    START_TRIP(data.id)
    .then(() => {
      setLoadingStart(false)
      onUpdate && onUpdate();
    })
    .catch((err) => {
      setLoadingStart(false)
      showNotification({title: "Ops", message: err.message, color: 'red'})
    })
  }
  
  const finishTrip = () => {
    setLoadingFinish(true)
    FINISH_TRIP(data.id)
    .then(() => {
      setLoadingFinish(false)
      onUpdate && onUpdate();
    })
    .catch((err) => {
      setLoadingFinish(false)
      showNotification({title: "Ops", message: err.message, color: 'red'})
    })
  }

  if(!data) return <Paper shadow="xs" p="md" style={{height: 'calc(100vh - 340px)', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
    <Title c="gray" size="sm">Selecione uma viagem para visualizar o trajeto e status</Title>
  </Paper>
  return <>
    <Paper shadow="xs" p="md" style={{minHeight: typePresent === "location" ? "85vh" : 'calc(100vh - 340px)', display: 'flex', flexDirection: 'column'}}>
      <div style={{flex: 1}}>
        {typePresent === "location" && <SimpleMap
          origin={data?.routeTrip?.origin}
          // icon={{
            // path: 'M11.0639 15.3003L26.3642 2.47559e-05L41.6646 15.3003L26.3638 51.3639L11.0639 15.3003 M22,17.5a4.5,4.5 0 1,0 9,0a4.5,4.5 0 1,0 -9,0Z',
            // path: vehiclePath,
            // fillColor: "#FF0000",
            // fillOpacity: 0.8,
            // strokeColor: 'pink',
            // strokeWeight: 2,
            // anchor: new google.maps.Point(30, 50)
        // }}
          height="75vh"
        />}
        {/* {typePresent === "route" && data?.route && <MapRender
          googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDV8uT7yErfIloYQBp_PXlEyJnTBWJ3Hpk"
          loadingElement={<Loader />}
          origin={data.routeTrip.origin}
          destination={data.routeTrip.destination}
          waypoints={data.routeTrip.waypoints}
          height="40vh"
        />} */}
        <SimpleMap
          line
          location={vehicle?.location}
          // icon={{
            // path: 'M11.0639 15.3003L26.3642 2.47559e-05L41.6646 15.3003L26.3638 51.3639L11.0639 15.3003 M22,17.5a4.5,4.5 0 1,0 9,0a4.5,4.5 0 1,0 -9,0Z',
            // path: vehiclePath,
            // fillColor: "#FF0000",
            // fillOpacity: 0.8,
            // strokeColor: 'pink',
            // strokeWeight: 2,
            // anchor: new google.maps.Point(30, 50)
        // }}
          markers={
            [
              data.routeTrip.origin,
              ...(data.routeTrip.waypoints ?? []).map(w => w.location),
              data.routeTrip.destination,
            ].filter(nn => nn)
          }
          height={"500px"}
        />
      </div>
      <Group p="md">
        {/* <TripInfo details={data} /> */}
        {/* <Button color="orange" variant="light" onClick={() => setTypePresent(tp => tp === "route" ? "location" : "route")}>
            {typePresent === "route" ? "Rota" : "Localização"}
        </Button> */}
        { data?.status === 0 && <Button color="red" variant="light" loading={loadingCancel} onClick={() => {
          app.confirmDialog(
            {text: "Realmente deseja cancelar essa viagem?"},
            (({confirmed}) => { if(confirmed) cancelTrip(); })
        )
        }}>Cancelar viagem</Button>}
        { [-1, 0].includes(data?.status) && <Button color="yellow" variant="light" loading={loadingStart} onClick={() => {
          app.confirmDialog(
            {text: "Realmente deseja iniciar essa viagem?"},
            (({confirmed}) => { if(confirmed) startTrip(); })
        )
        }}>Iniciar viagem</Button>}
        { [1].includes(data?.status) && <Button color="gray" variant="light" loading={loadingFinish} onClick={() => {
          app.confirmDialog(
            {text: "Realmente deseja finalizar essa viagem?"},
            (({confirmed}) => { if(confirmed) finishTrip(); })
        )
        }}>Finalizar viagem</Button>}
        { data && onEdit && <Button color="green" variant="outline" loading={loadingFinish} onClick={onEdit}>Editar</Button>}
        {/* <Button color="orange" variant="light">{Math.round(details.distance/1000)} km</Button> */}
        {/* <Button color="orange" variant="light">{Math.round(details.distance/1000)} km</Button> */}
      </Group>
    </Paper>
  </>
}
